/* eslint-disable no-param-reassign */
import { createAsyncThunk } from '@reduxjs/toolkit';

export const setActive = createAsyncThunk('savedSearches/setActive', async (id, { getState }) => {
  if (!id) {
    return { activeSavedSearch: null };
  }
  const activeSavedSearch = getState().savedSearches.all?.find((i) => i._id === id);
  return { activeSavedSearch };
});

export const reducer = (builder) => {
  builder.addCase(
    setActive.fulfilled,
    (state, { payload: { activeSavedSearch } }) => {
      state.activeSavedSearch = activeSavedSearch;
    },
  );
};
